import { render, staticRenderFns } from "./SpyderBrandsView.vue?vue&type=template&id=2d590dee&scoped=true"
import script from "./SpyderBrandsView.vue?vue&type=script&lang=js"
export * from "./SpyderBrandsView.vue?vue&type=script&lang=js"
import style0 from "./SpyderBrandsView.vue?vue&type=style&index=0&id=2d590dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d590dee",
  null
  
)

export default component.exports